import { render } from "./CrawlTriviaAnswer.vue?vue&type=template&id=f7f1a570&scoped=true"
import script from "./CrawlTriviaAnswer.vue?vue&type=script&lang=js"
export * from "./CrawlTriviaAnswer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-f7f1a570"

export default script